import { fetch } from '@atlassian/eoc-fetch';
import { generateLogParams } from '../../../common/utils';
export const fetchLogs = async params => {
  const urlParams = generateLogParams(params);
  return fetch('/v1/logs/search?' + urlParams.toString()).then(response => {
    if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) {
      return {
        ...response,
        data: {
          ...response.data,
          pagination: {
            ...response.data.pagination,
            calcStartDate: urlParams.get('startTimestamp'),
            calcEndDate: urlParams.get('endTimestamp')
          }
        }
      };
    }
    return response;
  });
};